import { defineStore } from "pinia";
import { ref, computed } from "vue";
import { useAgamaStore } from "@/stores/AgamaStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useJabatanDewasStore } from "@/stores/JabatanDewasStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePegawaiStatusStore } from "@/stores/PegawaiStatusStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useCutiJenisStore } from "@/stores/CutiJenisStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useGolonganStore } from "@/stores/GolonganStore";
import { usePendidikanJenjangStore } from "@/stores/PendidikanJenjangStore";
import { useArsipKategoriStore } from "@/stores/ArsipKategoriStore";
import { useStatusAktifStore } from "@/stores/StatusAktifStore";
import { useKeluargaHubStore } from "@/stores/KeluargaHubStore";
import { usePerkawinanStatusStore } from "@/stores/PerkawinanStatusStore";
import { useRoleStore } from "@/stores/RoleStore";
import { useMasterDataStore } from "@/stores/MasterDataStore";
// import { useGajiSkemaKomponenStore } from "@/stores/GajiSkemaKomponenStore";
// import { useGajiPokokSkemaDetailStore } from "@/stores/GajiPokokSkemaDetailStore";
// import { useGajiSkemaStore } from "@/stores/GajiSkemaStore";
// import { useGajiSkemaDirutStore } from "@/stores/GajiSkemaDirutStore";
// import { useGajiSkemaDirumStore } from "@/stores/GajiSkemaDirumStore";
// import { useGajiSkemaDewasStore } from "@/stores/GajiSkemaDewasStore";
// import { useGajiSkemaDirtekStore } from "@/stores/GajiSkemaDirtekStore";
// import { useGajiSkemaTetapStore } from "@/stores/GajiSkemaTetapStore";
// import { useGajiSkemaCapegStore } from "@/stores/GajiSkemaCapegStore";
// import { useGajiSkemaHonorStore } from "@/stores/GajiSkemaHonorStore";
// import { useGajiSkemaKontrakStore } from "@/stores/GajiSkemaKontrakStore";
// import { useGajiPokokSkemaStore } from "@/stores/GajiPokokSkemaStore";
// import { useTunJabatanStore } from "@/stores/TunJabatanStore";
// import { useTunJabatanDetailStore } from "@/stores/TunJabatanDetailStore";
// import { useTunPanganStore } from "@/stores/TunPanganStore";
// import { useTunPanganDetailStore } from "@/stores/TunPanganDetailStore";
// import { useTunAirStore } from "@/stores/TunAirStore";
import { usePenggajianStatusStore } from "@/stores/PenggajianStatusStore";

export const useCommonStore = defineStore("commonStore", () => {
  function clearStore() {
    /* DISABLE ALL SETTING GAJI
            useGajiSkemaKomponenStore().$reset();
            useGajiSkemaKomponenStore().$state = {data: null};
            useGajiPokokSkemaDetailStore().$reset();
            useGajiPokokSkemaDetailStore().$state = {data: null};
            useGajiSkemaDirutStore().$reset();
            useGajiSkemaDirutStore().$state = {data: null};
            useGajiSkemaStore().$reset();
            useGajiSkemaStore().$state = {data: null};
            useGajiSkemaDirumStore().$reset();
            useGajiSkemaDirumStore().$state = {data: null};
            useGajiSkemaDewasStore().$reset();
            useGajiSkemaDewasStore().$state = {data: null};
            useGajiSkemaDirtekStore().$reset();
            useGajiSkemaDirtekStore().$state = {data: null};
            useGajiSkemaTetapStore().$reset();
            useGajiSkemaTetapStore().$state = {data: null};
            useGajiSkemaCapegStore().$reset();
            useGajiSkemaCapegStore().$state = {data: null};
            useGajiSkemaHonorStore().$reset();
           useGajiSkemaKontrakStore().$reset();
            useGajiSkemaKontrakStore().$state = {data: null};
            useGajiPokokSkemaStore().$reset();
            useGajiPokokSkemaStore().$state = {data: null};
            useTunJabatanStore().$reset();
            useTunJabatanStore().$state = {data: null};
            useTunJabatanDetailStore().$reset();
            useTunJabatanDetailStore().$state = {data: null};
            useTunAirStore().$reset();
            useTunAirStore().$state = {data: null};
            useTunPanganStore().$reset();
            useTunPanganStore().$state = {data: null};
            useTunPanganDetailStore().$reset();
            useTunPanganDetailStore().$state = {data: null};
            */

    useArsipKategoriStore().$state = { data: null };

    usePenggajianStatusStore().$reset();
    usePenggajianStatusStore().$state = { data: null };

    useStatusAktifStore().$reset();
    useStatusAktifStore().$state = { data: null };

    usePegawaiStatusStore().$reset();
    usePegawaiStatusStore().$state = { data: null };

    useBagianStore().$reset();
    useBagianStore().$state = { data: null };

    useCutiJenisStore().$reset();
    useCutiJenisStore().$state = { data: null };

    useSubBagianStore().$reset();
    useSubBagianStore().$state = { data: null };

    useBidangStore().$reset();
    useBidangStore().$state = { data: null };

    useSubBidangStore().$reset();
    useSubBidangStore().$state = { data: null };

    useSeksiStore().$reset();
    useSeksiStore().$state = { data: null };

    useGolonganStore().$reset();
    useGolonganStore().$state = { data: null };

    useArsipKategoriStore().$reset();
    useArsipKategoriStore().$state = { data: null };

    useAgamaStore().$reset();
    useAgamaStore().$state = { data: null };

    usePerkawinanStatusStore().$reset();
    usePerkawinanStatusStore().$state = { data: null };

    useKeluargaHubStore().$reset();
    useKeluargaHubStore().$state = { data: null };

    useJabatanStore().$reset();
    useJabatanStore().$state = { data: null };

    useJabatanDewasStore().$reset();
    useJabatanDewasStore().$state = { data: null };

    useCabangStore().$reset();
    useCabangStore().$state = { data: null };

    usePendidikanJenjangStore().$reset();
    usePendidikanJenjangStore().$state = { data: null };

    useUnitStore().$reset();
    useUnitStore().$state = { data: null };

    useRoleStore().$reset();
    useRoleStore().$state = { data: null };

    // Object.keys(localStorage).forEach((key) => {

    //     if (key.startsWith('pinia')) {
    //         console.log("commonStore clearStore localStorage", key)
    //       localStorage.removeItem(key);
    //     }
    //   });
  }

  const arsipKategoriStore = ref(null);
  const agamaStore = ref(null);
  const statusAktifStore = ref(null);
  const perkawinanStatusStore = ref(null);
  const keluargaHubStore = ref(null);
  const jabatanStore = ref(null);
  const jabatanDewasStore = ref(null);
  const cabangStore = ref(null);
  const pendidikanJenjangStore = ref(null);
  const unitStore = ref(null);
  const pegawaiStatusStore = ref(null);
  const bagianStore = ref(null);
  const subBagianStore = ref(null);
  const bidangStore = ref(null);
  const subBidangStore = ref(null);
  const seksiStore = ref(null);
  const golonganStore = ref(null);
  const penggajianStatusStore = ref(null);
  const cutiJenisStore = ref(null);
  const roleStore = ref(null);

  /*
            statusPengajuanSource2,
        const gajiSkemaKomponenStore = ref(null); 
        const gajiPokokSkemaDetailStore = ref(null); 
        const gajiSkemaStore = ref(null); 
        const gajiSkemaDirutStore = ref(null); 
        const gajiSkemaDirumStore = ref(null); 
        const gajiSkemaDewasStore = ref(null); 
        const gajiSkemaDirtekStore = ref(null); 
        const gajiSkemaTetapStore = ref(null); 
        const gajiSkemaCapegStore = ref(null); 
        const gajiSkemaHonorStore = ref(null); 
        const gajiSkemaKontrakStore = ref(null); 
        const gajiPokokSkemaStore = ref(null); 
        const tunJabatanStore = ref(null); 
        const tunJabatanDetailStore = ref(null); 
        const tunPanganStore = ref(null); 
        const tunPanganDetailStore = ref(null); 
        const tunAirStore = ref(null); 
        */

  async function resetStore(store, storeRef, condition = null) {
    // Check if the store already has data
    if (store.data && store.data.length > 0) {
      // Apply the filter condition if provided
      storeRef.value = condition ? store.data.filter(condition) : store.data;
      //   console.log("commonStore resetStore if 1 " + from, storeRef.value);
    } else if (!storeRef.value || storeRef.value.length === 0) {
      // Fetch data and apply the filter condition if provided
      const fetchedData = await store.get();
      storeRef.value = condition ? fetchedData.filter(condition) : fetchedData;
      //   console.log("commonStore resetStore if 2 " + from, storeRef.value);
    } else {
      //   console.log("commonStore resetStore 3 " + from, storeRef.value);
    }
    return storeRef.value;
  }

  async function reloadStore(store, storeRef, condition = null) {
    const fetchedData = await store.reset();
    storeRef.value = condition ? fetchedData.filter(condition) : fetchedData;
    return storeRef.value;
  }

  async function forceReloadStoreAfterLogin() {
    //after login, reload all dataaa

    this.clearStore();
    const master = useMasterDataStore();
    await master.reset();
    await Promise.all([
      //setting gaji store --> all disabled
      // reloadStore(useGajiSkemaKomponenStore(), gajiSkemaKomponenStore),
      // reloadStore(useGajiPokokSkemaDetailStore(), gajiPokokSkemaDetailStore),
      // reloadStore(useGajiSkemaDirutStore(), gajiSkemaDirutStore),
      // reloadStore(useGajiSkemaStore(), gajiSkemaStore),
      // reloadStore(useGajiSkemaDirumStore(), gajiSkemaDirumStore),
      // reloadStore(useGajiSkemaDirtekStore(), gajiSkemaDirtekStore),
      // reloadStore(useGajiSkemaDewasStore(), gajiSkemaDewasStore),
      // reloadStore(useGajiSkemaTetapStore(), gajiSkemaTetapStore),
      // reloadStore(useGajiSkemaCapegStore(), gajiSkemaCapegStore),
      // reloadStore(useGajiSkemaHonorStore(), gajiSkemaHonorStore),
      // reloadStore(useGajiSkemaKontrakStore(), gajiSkemaKontrakStore),
      // reloadStore(useGajiPokokSkemaStore(), gajiPokokSkemaStore),
      // reloadStore(useTunJabatanStore(), tunJabatanStore),
      // reloadStore(useTunJabatanDetailStore(), tunJabatanDetailStore),
      // reloadStore(useTunPanganStore(), tunPanganStore),
      // reloadStore(useTunPanganDetailStore(), tunPanganDetailStore),
      // reloadStore(useTunAirStore(), tunAirStore),

      reloadStore(usePerkawinanStatusStore(), perkawinanStatusStore),
      reloadStore(useKeluargaHubStore(), keluargaHubStore),
      reloadStore(usePenggajianStatusStore(), penggajianStatusStore),
      reloadStore(useArsipKategoriStore(), arsipKategoriStore),
      reloadStore(useAgamaStore(), agamaStore),
      reloadStore(useStatusAktifStore(), statusAktifStore),
      reloadStore(useCutiJenisStore(), cutiJenisStore),
      //   resetStore(useJabatanStore(), jabatanStore),//asli
      reloadStore(
        useJabatanStore(),
        jabatanStore,
        (item) => item.is_dewas === false,
      ),
      reloadStore(
        useJabatanStore(),
        jabatanDewasStore,
        (item) => item.is_dewas === true,
      ),
      reloadStore(useCabangStore(), cabangStore),
      reloadStore(usePendidikanJenjangStore(), pendidikanJenjangStore),
      reloadStore(useUnitStore(), unitStore),
      reloadStore(usePegawaiStatusStore(), pegawaiStatusStore),
      reloadStore(useBagianStore(), bagianStore),
      reloadStore(useSubBagianStore(), subBagianStore),
      reloadStore(useBidangStore(), bidangStore),
      reloadStore(useSubBidangStore(), subBidangStore),
      reloadStore(useSeksiStore(), seksiStore),
      reloadStore(useGolonganStore(), golonganStore),
      reloadStore(useRoleStore(), roleStore),
    ]);
  }

  async function preloadStores() {
    const master = useMasterDataStore();
    await master.get();

    await Promise.all([
      //setting gaji store --> all disabled

      /*  resetStore(useGajiSkemaKomponenStore(), gajiSkemaKomponenStore),
             resetStore(useGajiPokokSkemaDetailStore(), gajiPokokSkemaDetailStore),
              resetStore(useGajiSkemaDirutStore(), gajiSkemaDirutStore),
              resetStore(useGajiSkemaStore(), gajiSkemaStore),
              resetStore(useGajiSkemaDirumStore(), gajiSkemaDirumStore),
              resetStore(useGajiSkemaDirtekStore(), gajiSkemaDirtekStore, "dirtek"),
              resetStore(useGajiSkemaDewasStore(), gajiSkemaDewasStore, "dewas"),
              resetStore(useGajiSkemaTetapStore(), gajiSkemaTetapStore, "tetap"),
              resetStore(useGajiSkemaCapegStore(), gajiSkemaCapegStore, "capeg"),
              resetStore(useGajiSkemaHonorStore(), gajiSkemaHonorStore, "honor"),
              resetStore(useGajiSkemaKontrakStore(), gajiSkemaKontrakStore, "kontrak"),
              resetStore(useGajiPokokSkemaStore(), gajiPokokSkemaStore, "gajipokok"),
              resetStore(useTunJabatanStore(), tunJabatanStore),
              resetStore(useTunJabatanDetailStore(), tunJabatanDetailStore),
              resetStore(useTunPanganStore(), tunPanganStore),
              resetStore(useTunPanganDetailStore(), tunPanganDetailStore),
              resetStore(useTunAirStore(), tunAirStore),
                */

      resetStore(usePerkawinanStatusStore(), perkawinanStatusStore),
      resetStore(useKeluargaHubStore(), keluargaHubStore),
      resetStore(usePenggajianStatusStore(), penggajianStatusStore),
      resetStore(useArsipKategoriStore(), arsipKategoriStore),
      resetStore(useAgamaStore(), agamaStore),
      resetStore(useStatusAktifStore(), statusAktifStore),
      resetStore(useCutiJenisStore(), cutiJenisStore),
      //   resetStore(useJabatanStore(), jabatanStore),//asli
      resetStore(
        useJabatanStore(),
        jabatanStore,
        (item) => item.is_dewas === false,
      ),
      resetStore(
        useJabatanStore(),
        jabatanDewasStore,
        (item) => item.is_dewas === true,
      ),
      resetStore(useCabangStore(), cabangStore),
      resetStore(usePendidikanJenjangStore(), pendidikanJenjangStore),
      resetStore(useUnitStore(), unitStore),
      resetStore(usePegawaiStatusStore(), pegawaiStatusStore),
      resetStore(useBagianStore(), bagianStore),
      resetStore(useSubBagianStore(), subBagianStore),
      resetStore(useBidangStore(), bidangStore),
      resetStore(useSubBidangStore(), subBidangStore),
      resetStore(useSeksiStore(), seksiStore),
      resetStore(useGolonganStore(), golonganStore),
      resetStore(useRoleStore(), roleStore),
    ]);
  }

  const statusGajiStore = [
    { val: true, nama: "Approved" },
    { val: false, nama: "Belum Approved" },
  ];

  const jenisHukumanStore = [
    { val: "Teguran Lisan", nama: "Teguran Lisan" },
    { val: "Teguran Tertulis", nama: "Teguran Tertulis" },
    { val: "Penundaan KGB", nama: "Penundaan KGB" },
    { val: "Penundaan KP", nama: "Penundaan KP" },
    { val: "Pemberhentian dengan Hormat", nama: "Pemberhentian dengan Hormat" },
    {
      val: "Pemberhentian dengan Tidak Hormat",
      nama: "Pemberhentian dengan Tidak Hormat",
    },
  ];

  const tipeHariLiburStore = [
    { val: "Hari Libur Nasional", nama: "Hari Libur Nasional" },
    {
      val: "Hari Libur dan Dispensasi Hari Raya",
      nama: "Hari Libur dan Dispensasi Hari Raya",
    },
    { val: "Cuti Bersama", nama: "Cuti Bersama" },
  ];

  const tingkatanPeringatanStore = [
    { val: "SP 1", nama: "SP 1" },
    { val: "SP 2", nama: "SP 2" },
    { val: "SP 3", nama: "SP 3" },
  ];

  const jenisPengajuanStore = [
    { val: "KP", nama: "KP" },
    { val: "KGB", nama: "KGB" },
  ];

  const statusUserStore = [
    { val: "ACTIVE" },
    { val: "PENDING" },
    { val: "SUSPENDED" },
  ];

  const statusPengajuanStore = [
    { val: 0, nama: "Diajukan" },
    { val: 1, nama: "Disetujui" },
    { val: 2, nama: "Ditolak" },
  ];

  const editedByUserStore = [
    { val: true, nama: "Diedit user" },
    { val: false, nama: "Dibuat sistem" },
  ];

  const jenisHukumanSource = computed(() => {
    return jenisHukumanStore.map((item) => {
      return {
        text: item.nama,
        value: ["jenis_hukuman", "=", item.val],
      };
    });
  });

  const tipeHariLiburSource = computed(() => {
    return tipeHariLiburStore.map((item) => {
      return {
        text: item.nama,
        value: ["tipe", "=", item.val],
      };
    });
  });

  const tingkatanPeringatanSource = computed(() => {
    return tingkatanPeringatanStore.map((item) => {
      return {
        text: item.nama,
        value: ["tingkatan_peringatan", "=", item.val],
      };
    });
  });

  const jenisPengajuanSource = computed(() => {
    if (!jenisPengajuanStore) {
      return []; // If data is not ready, return an empty array
    }
    return jenisPengajuanStore.map((item) => {
      return {
        text: item.nama,
        value: ["jenis", "=", item.val],
      };
    });
  });

  const statusUserSource = computed(() => {
    if (!statusUserStore) {
      return []; // If data is not ready, return an empty array
    }
    const result = statusUserStore.map((item) => {
      return {
        text: item.val,
        value: ["status", "=", item.val],
      };
    });

    // Ensure PENDING is included in the returned options
    // if (!result.some((r) => r.value && r.value[2] === "PENDING")) {
    //   result.push({ text: "PENDING", value: ["status", "=", "PENDING"] });
    // }

    return result;
  });
  const editedByUserSource = computed(() => {
    if (!editedByUserStore) {
      return []; // If data is not ready, return an empty array
    }
    return editedByUserStore.map((item) => {
      return {
        text: item.nama,
        value: ["edited_by_user", "=", item.val],
      };
    });
  });

  const statusPengajuanSource = computed(() => {
    if (!statusPengajuanStore) {
      return []; // If data is not ready, return an empty array
    }
    return statusPengajuanStore.map((item) => {
      return {
        text: item.nama,
        value: ["status", "=", item.val],
      };
    });
  });

  // Returns an array for header-filter, with dynamic field name (e.g. 'status' or 'cutis_status')
  // function statusPengajuanSource2(field = "status") {
  //   if (!statusPengajuanStore) {
  //     return [];
  //   }
  //   return statusPengajuanStore.map((item) => {
  //     return {
  //       text: item.nama,
  //       value: [field, "=", item.val],
  //     };
  //   });
  // }

  function statusPengajuanSource2(field = "status") {
    return computed(() => {
      if (!statusPengajuanStore) {
        return []; // If data is not ready, return an empty array
      }

      return statusPengajuanStore.map((item) => {
        return {
          text: item.nama,
          value: [field, "=", item.val],
        };
      });
    });
  }

  const statusStore = [
    { val: true, nama: "Aktif" },
    { val: false, nama: "Tidak Aktif" },
  ];
  const statusSertifikatStore = [
    { val: true, nama: "Ada" },
    { val: false, nama: "Tidak Ada" },
  ];
  const statusIsDewasStore = [
    { val: true, nama: "Dewan Pengawas" },
    { val: false, nama: "Sekretariat Dewan Pengawas" },
  ];

  const statusCapegStore = [
    { val: true, nama: "80%" },
    { val: false, nama: null },
  ];

  const statusPtkpStore = [
    { nama: null },
    { nama: "TK" },
    { nama: "K0" },
    { nama: "K1" },
    { nama: "K2" },
    { nama: "K3" },
  ];

  const jenisPenghargaanStore = [
    { nama: null },
    { nama: "Tanda Jasa MK 10 Thn" },
    { nama: "Tanda Jasa MK 20 Thn" },
    { nama: "Tanda Jasa MK 30 Thn" },
  ];

  const tipeNaikPangkatStore = [
    { nama: null },
    { nama: "Reguler" },
    { nama: "Penyesuaian" },
    { nama: "Pilihan" },
    { nama: "Pengabdian" },
  ];

  const statusJabatanStore = [
    { nama: "Definitif" },
    { nama: "Plt" },
    { nama: "Plh" },
  ];

  const jenisKelaminStore = [{ nama: "L" }, { nama: "P" }];

  const statusPenyesuaianStore = [
    { val: true, nama: "Penyesuaian" },
    { val: false, nama: null },
  ];

  const statusKoorStore = [
    { val: true, nama: "Koordinator Pelaksana" },
    { val: false, nama: null },
  ];

  const statusTertanggungStore = [
    { val: true, nama: "Tertanggung" },
    { val: false, nama: null },
  ];

  const jabatanSource = computed(() => {
    if (!jabatanStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return jabatanStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["jabatans_nama", "=", item.nama],
      };
    });
  });

  const jabatanDewasSource = computed(() => {
    if (!jabatanDewasStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return jabatanDewasStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["jabatans_nama", "=", item.nama],
      };
    });
  });

  const keluargaHubSource = computed(() => {
    if (!keluargaHubStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return keluargaHubStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["keluarga_hubs_nama", "=", item.nama],
      };
    });
  });
  const pendidikanJenjangSource = computed(() => {
    if (!pendidikanJenjangStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return pendidikanJenjangStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["pendidikan_jenjang_id", "=", item.id],
      };
    });
  });

  const perkawinanStatusSource = computed(() => {
    if (!perkawinanStatusStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return perkawinanStatusStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["perkawinan_statuses_nama", "=", item.nama],
      };
    });
  });

  const statusSource = computed(() => {
    if (!statusStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusStore.map((item) => {
      return {
        text: item.nama,
        value: ["status", "=", item.val],
      };
    });
  });

  const statusSertifikatSource = computed(() => {
    if (!statusSertifikatStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusSertifikatStore.map((item) => {
      return {
        text: item.nama,
        value: ["sertifikat", "=", item.val],
      };
    });
  });

  const statusCapegSource = computed(() => {
    if (!statusCapegStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusCapegStore.map((item) => {
      return {
        text: item.nama,
        value: ["capeg", "=", item.val],
      };
    });
  });

  const statusCapegPrediksiKpSource = computed(() => {
    if (!statusCapegStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusCapegStore.map((item) => {
      return {
        text: item.nama,
        value: ["simpeg_naik_pangkats_capeg", "=", item.val],
      };
    });
  });

  const statusPtkpSource = computed(() => {
    if (!statusPtkpStore) {
      return []; // If data is not ready, return an empty array
    }
    return statusPtkpStore.map((item) => {
      return {
        text: item.nama,
        value: ["ptkp", "=", item.nama],
      };
    });
  });

  const jenisPenghargaanSource = computed(() => {
    if (!jenisPenghargaanStore) {
      return []; // If data is not ready, return an empty array
    }
    return jenisPenghargaanStore.map((item) => {
      return {
        text: item.nama,
        value: ["jenis", "=", item.nama],
      };
    });
  });

  const tipeNaikPangkatSource = computed(() => {
    if (!tipeNaikPangkatStore) {
      return []; // If data is not ready, return an empty array
    }

    return tipeNaikPangkatStore.map((item) => {
      return {
        text: item.nama,
        value: ["simpeg_naik_pangkats_tipe", "=", item.nama],
      };
    });
  });

  const statusJabatanSource = computed(() => {
    if (!statusJabatanStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusJabatanStore.map((item) => {
      return {
        text: item.nama,
        value: ["status_jabatan", "=", item.nama],
      };
    });
  });

  const jenisKelaminSource = computed(() => {
    if (!jenisKelaminStore) {
      return []; // If data is not ready, return an empty array
    }

    return jenisKelaminStore.map((item) => {
      return {
        text: item.nama,
        value: ["jenis_kelamin", "=", item.nama],
      };
    });
  });

  const statusAktifSource = computed(() => {
    if (!statusAktifStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return statusAktifStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["status_aktifs_nama", "=", item.nama],
      };
    });
  });

  const statusGajiSource = computed(() => {
    if (!statusGajiStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusGajiStore.map((item) => {
      return {
        text: item.nama,
        value: ["gajis_status_gaji", "=", item.val],
      };
    });
  });

  const statusPenyesuaianSource = computed(() => {
    if (!statusPenyesuaianStore) {
      return []; // If data is not ready, return an empty array
    }
    return statusPenyesuaianStore.map((item) => {
      return {
        text: item.nama,
        value: ["status_penyesuaian", "=", item.val],
      };
    });
  });

  const statusKoorSource = computed(() => {
    if (!statusKoorStore) {
      return []; // If data is not ready, return an empty array
    }
    return statusKoorStore.map((item) => {
      return {
        text: item.nama,
        value: ["koor", "=", item.val],
      };
    });
  });

  const statusTertanggungSource = computed(() => {
    if (!statusTertanggungStore) {
      return []; // If data is not ready, return an empty array
    }

    return statusTertanggungStore.map((item) => {
      return {
        text: item.nama,
        value: ["status_tertanggung", "=", item.val],
      };
    });
  });

  const golonganSource = computed(() => {
    if (!golonganStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return golonganStore.value.map((item) => {
      return {
        text: item.nama,
        // value: ['golongans_nama', '=', item.nama],
        value: ["golongans_id", "=", item.id],
      };
    });
  });

  const roleSource = computed(() => {
    if (!roleStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return roleStore.value.map((item) => {
      return {
        text: item.nama,
        // value: ['golongans_nama', '=', item.nama],
        value: ["roles_id", "=", item.id],
      };
    });
  });

  const golonganNaikPangkatsSource = computed(() => {
    if (!golonganStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return golonganStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["golongan_naik_pangkats_nama", "=", item.nama],
      };
    });
  });

  const golonganPrediksisSource = computed(() => {
    if (!golonganStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return golonganStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["golongan_prediksis_nama", "=", item.nama],
      };
    });
  });

  const cabangSource = computed(() => {
    if (!cabangStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return cabangStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["cabangs_nama", "=", item.nama],
      };
    });
  });

  const unitSource = computed(() => {
    if (!unitStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return unitStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["units_nama", "=", item.nama],
      };
    });
  });

  const pegawaiStatusSource = computed(() => {
    if (!pegawaiStatusStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return pegawaiStatusStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["pegawai_statuses_nama", "=", item.nama],
      };
    });
  });

  function getPegawaiStatusSource(variablePassed = null) {
    return computed(() => {
      if (!pegawaiStatusStore.value) {
        return []; // If data is not ready, return an empty array
      }

      return pegawaiStatusStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["pegawai_status_id", "=", item.id]
              : ["pegawai_statuses_nama", "=", item.nama],
        };
      });
    });
  }

  // const statusPtkpSource = (someVariable = null) => {
  //     console.log("statusPtkpSource someVariable", someVariable)
  //     return computed(() => {
  //         console.log("statusPtkpSource computed")
  //         if (!statusPtkpStore) {
  //             console.log("statusPtkpSource return null")
  //             return []; // If data is not ready, return an empty array
  //         }
  //         return statusPtkpStore.map((item) => {
  //             return {
  //                 text: item.nama,
  //                 value: ['status_ptkp', '=', item[someVariable]], // Use the passed variable or default to 'nama'
  //             };
  //         });
  //     });
  // };

  const bagianSource = computed(() => {
    if (!bagianStore.value) {
      return []; // If data is not ready, return an empty array
    }

    return bagianStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["bagians_nama", "=", item.nama],
      };
    });
  });

  const subBagianSource = computed(() => {
    if (!subBagianStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return subBagianStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["sub_bagians_nama", "=", item.nama],
      };
    });
  });

  const bidangSource = computed(() => {
    if (!bidangStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return bidangStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["bidangs_nama", "=", item.nama],
      };
    });
  });

  const subBidangSource = computed(() => {
    if (!subBidangStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return subBidangStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["sub_bidangs_nama", "=", item.nama],
      };
    });
  });

  const seksiSource = computed(() => {
    if (!seksiStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return seksiStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["seksis_nama", "=", item.nama],
      };
    });
  });

  const agamaSource = computed(() => {
    if (!agamaStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return agamaStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["agamas_nama", "=", item.nama],
      };
    });
  });

  const penggajianStatusSource = computed(() => {
    if (!penggajianStatusStore.value) {
      return []; // If data is not ready, return an empty array
    }
    return penggajianStatusStore.value.map((item) => {
      return {
        text: item.nama,
        value: ["gaji_statuses_nama", "=", item.nama],
      };
    });
  });

  function getGolonganSource(variablePassed = null) {
    return computed(() => {
      if (!golonganStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return golonganStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["golongans_id", "=", item.id]
              : ["golongans_nama", "=", item.nama],
        };
      });
    });
  }

  function getRoleSource(variablePassed = null) {
    return computed(() => {
      if (!roleStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return roleStore.value.map((item) => {
        return {
          text: item.name,
          value:
            variablePassed === "crud"
              ? ["roles_id", "=", item.id]
              : ["roles_name", "=", item.name],
        };
      });
    });
  }

  function getCutiJenisSource(variablePassed = null) {
    return computed(() => {
      if (!cutiJenisStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return cutiJenisStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["cuti_jenis_id", "=", item.id]
              : ["cuti_jenis_nama", "=", item.nama],
        };
      });
    });
  }

  function getTipeNaikPangkatSource(variablePassed = null) {
    return computed(() => {
      if (!tipeNaikPangkatStore) {
        return []; // If data is not ready, return an empty array
      }
      return tipeNaikPangkatStore.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["tipe", "=", item.nama] //tidak punya id
              : ["simpeg_naik_pangkats_tipe", "=", item.nama],
        };
      });
    });
  }

  function getJabatanSource(variablePassed = null) {
    return computed(() => {
      if (!jabatanStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return jabatanStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["jabatan_id", "=", item.id] //tidak punya id
              : ["jabatans_nama", "=", item.nama],
        };
      });
    });
  }

  function getJabatanDewasSource(variablePassed = null) {
    return computed(() => {
      if (!jabatanDewasStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return jabatanDewasStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["jabatan_id", "=", item.id] //tidak punya id
              : ["jabatans_nama", "=", item.nama],
        };
      });
    });
  }

  function getCabangSource(variablePassed = null) {
    return computed(() => {
      if (!cabangStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return cabangStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["cabang_id", "=", item.id] //tidak punya id
              : ["cabangs_nama", "=", item.nama],
        };
      });
    });
  }

  function getUnitSource(variablePassed = null) {
    return computed(() => {
      if (!unitStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return unitStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["unit_id", "=", item.id] //tidak punya id
              : ["units_nama", "=", item.nama],
        };
      });
    });
  }

  function getBagianSource(variablePassed = null) {
    return computed(() => {
      if (!golonganStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return bagianStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["bagian_id", "=", item.id] //tidak punya id
              : ["bagians_nama", "=", item.nama],
        };
      });
    });
  }

  function getSubBagianSource(variablePassed = null) {
    return computed(() => {
      if (!subBagianStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return subBagianStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["sub_bagian_id", "=", item.id] //tidak punya id
              : ["sub_bagians_nama", "=", item.nama],
        };
      });
    });
  }

  function getBidangSource(variablePassed = null) {
    return computed(() => {
      if (!bidangStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return bidangStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["bidang_id", "=", item.id] //tidak punya id
              : ["bidangs_nama", "=", item.nama],
        };
      });
    });
  }

  function getSubBidangSource(variablePassed = null) {
    return computed(() => {
      if (!subBidangStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return subBidangStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["sub_bidang_id", "=", item.id] //tidak punya id
              : ["sub_bidangs_nama", "=", item.nama],
        };
      });
    });
  }

  function getSeksiSource(variablePassed = null) {
    return computed(() => {
      if (!seksiStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return seksiStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["seksi_id", "=", item.id] //tidak punya id
              : ["seksis_nama", "=", item.nama],
        };
      });
    });
  }

  function getPendidikanJenjangSource(variablePassed = null) {
    return computed(() => {
      if (!pendidikanJenjangStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return pendidikanJenjangStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["pendidikan_jenjang_id", "=", item.id] //tidak punya id
              : ["pendidikan_jenjangs_nama", "=", item.nama],
        };
      });
    });
  }

  function getKeluargaHubSource(variablePassed = null) {
    return computed(() => {
      if (!keluargaHubStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return keluargaHubStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["keluarga_hub_id", "=", item.id] //tidak punya id
              : ["keluarga_hubs_nama", "=", item.nama],
        };
      });
    });
  }

  function getPerkawinanStatusSource(variablePassed = null) {
    return computed(() => {
      if (!perkawinanStatusStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return perkawinanStatusStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["perkawinan_status_id", "=", item.id] //tidak punya id
              : ["perkawinan_statuses_nama", "=", item.nama],
        };
      });
    });
  }

  function getAgamaSource(variablePassed = null) {
    return computed(() => {
      if (!agamaStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return agamaStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["agama_id", "=", item.id] //tidak punya id
              : ["agamas_nama", "=", item.nama],
        };
      });
    });
  }

  function getArsipKategoriSource(variablePassed = null) {
    return computed(() => {
      if (!arsipKategoriStore.value) {
        return []; // If data is not ready, return an empty array
      }
      return arsipKategoriStore.value.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["arsip_kategori_id", "=", item.id] //tidak punya id
              : ["arsip_kategoris_nama", "=", item.nama],
        };
      });
    });
  }

  function getPegawaiSource(pegawaiStore, variablePassed = null) {
    return computed(() => {
      if (!pegawaiStore) {
        return []; // If data is not ready, return an empty array
      }
      return pegawaiStore.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["arsip_pegawais_pegawai_ids", "=", item.id] //tidak punya id
              : ["pegawai_id", "=", item.id], //filtering from pengajuan-list
        };
      });
    });
  }

  function getPenilaiSource(pegawaiStore, variablePassed = null) {
    return computed(() => {
      if (!pegawaiStore) {
        return []; // If data is not ready, return an empty array
      }
      return pegawaiStore.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["arsip_pegawais_pegawai_ids", "=", item.id] //tidak punya id
              : ["penilai_id", "=", item.id], //filtering from pengajuan-list
        };
      });
    });
  }

  function getAtasanPenilaiSource(pegawaiStore, variablePassed = null) {
    return computed(() => {
      if (!pegawaiStore) {
        return []; // If data is not ready, return an empty array
      }
      return pegawaiStore.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["arsip_pegawais_pegawai_ids", "=", item.id] //tidak punya id
              : ["atasan_penilai_id", "=", item.id], //filtering from pengajuan-list
        };
      });
    });
  }

  function getDewasSource(dewasStore, variablePassed = null) {
    return computed(() => {
      if (!dewasStore) {
        return []; // If data is not ready, return an empty array
      }
      return dewasStore.map((item) => {
        return {
          text: item.nama,
          value:
            variablePassed === "crud"
              ? ["arsip_dewas_dewas_ids", "=", item.id] //tidak punya id
              : ["dewas_id", "=", item.id], //filtering from pengajuan-list
        };
      });
    });
  }

  return {
    preloadStores,
    getGolonganSource,
    getRoleSource,
    getTipeNaikPangkatSource,
    agamaSource,
    jabatanStore,
    jabatanDewasStore,
    jabatanSource,
    jabatanDewasSource,
    cabangStore,
    cabangSource,
    unitStore,
    unitSource,
    pegawaiStatusStore,
    pegawaiStatusSource,
    bagianStore,
    cutiJenisStore,

    getCutiJenisSource,
    bagianSource,
    subBagianStore,
    subBagianSource,
    bidangStore,
    bidangSource,
    subBidangStore,
    subBidangSource,
    seksiStore,
    seksiSource,
    golonganStore,
    roleStore,
    roleSource,
    golonganSource,
    statusGajiStore,
    statusGajiSource,
    arsipKategoriStore,

    statusAktifSource,
    statusPtkpStore,
    statusPtkpSource,
    jenisPenghargaanStore,
    jenisPenghargaanSource,

    jenisKelaminStore,
    jenisKelaminSource,
    tipeNaikPangkatSource,
    tipeNaikPangkatStore,
    statusStore,
    statusSource,
    statusPenyesuaianStore,
    statusPenyesuaianSource,
    statusKoorStore,
    statusKoorSource,

    pendidikanJenjangStore,
    pendidikanJenjangSource,
    golonganNaikPangkatsSource,
    golonganPrediksisSource,
    keluargaHubStore,
    keluargaHubSource,
    perkawinanStatusStore,
    perkawinanStatusSource,
    statusTertanggungSource,
    statusCapegStore,
    statusCapegSource,
    statusCapegPrediksiKpSource,
    statusJabatanStore,
    statusJabatanSource,
    getPegawaiStatusSource,
    getJabatanSource,
    getJabatanDewasSource,
    getCabangSource,
    getUnitSource,
    getBagianSource,
    getSubBagianSource,
    getBidangSource,
    getSubBidangSource,
    getSeksiSource,
    getPendidikanJenjangSource,
    getKeluargaHubSource,
    statusTertanggungStore,
    getPerkawinanStatusSource,
    getAgamaSource,
    agamaStore,
    statusAktifStore,
    getArsipKategoriSource,
    getPegawaiSource,
    getDewasSource,
    jenisPengajuanStore,
    jenisPengajuanSource,
    statusUserStore,
    statusUserSource,
    statusPengajuanStore,
    statusPengajuanSource,
    statusPengajuanSource2,
    clearStore,
    penggajianStatusStore,
    penggajianStatusSource,
    editedByUserSource,
    editedByUserStore,
    jenisHukumanStore,
    jenisHukumanSource,
    tipeHariLiburStore,
    tipeHariLiburSource,
    statusIsDewasStore,
    statusSertifikatStore,
    statusSertifikatSource,
    tingkatanPeringatanSource,
    tingkatanPeringatanStore,
    forceReloadStoreAfterLogin,
    getPenilaiSource,
    getAtasanPenilaiSource,

    /*
            gajiSkemaKomponenStore,
            gajiPokokSkemaDetailStore,
            gajiSkemaDirutStore,
            gajiSkemaStore,
            gajiSkemaDirumStore,
            gajiSkemaDewasStore,
            gajiSkemaDirtekStore,
            gajiSkemaTetapStore,
            gajiSkemaCapegStore,
            gajiSkemaHonorStore,
            gajiSkemaKontrakStore,
            gajiPokokSkemaStore,
            tunJabatanStore,
            tunJabatanDetailStore,
            tunPanganStore,
            tunPanganDetailStore,
            tunAirStore,
           */
  };
});
